import { render, staticRenderFns } from "./BaseAdminContentView.vue?vue&type=template&id=4dba0cec&scoped=true&"
import script from "./BaseAdminContentView.vue?vue&type=script&lang=js&"
export * from "./BaseAdminContentView.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdminContentView.vue?vue&type=style&index=0&id=4dba0cec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba0cec",
  null
  
)

export default component.exports